module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"privacyPolicy":"Privacy Policy","termsOfService":"Terms of Service"},"hr":{"privacyPolicy":"Politika privatnosti","termsOfService":"Uvjeti korištenja"}}')
  delete Component.options._Ctor
}
